// @flow
import Ingest from '@cchome/ingest-react';
import analyticsUtil from '../utils/AnalyticsUtil';
import ingestUtil from '../utils/IngestUtil';
import appsUtil from '../utils/AppsUtil';
import DeviceDetectionUtil from '../utils/DeviceDetectionUtil';
import {productData} from '../constants/ccdConstants';
import {setExpCampaignAndVariation} from '../utils/TestUtil';
import CompatibilityUtil from '../utils/CompatibilityUtil';

let logAnalytics = 0;
let logMetricsCollection = 0;
const constants = {
	rsidDev: 'adbem-cchome-dev',
	rsidProd: 'adbem-cchome-prod'
};

export default class CCDIngestAnalytics {
	ingest: Object;

	constructor(env: string) {
		const initObj = analyticsUtil.initAnalytics();
		if (env) {
			initObj.environment = env;
		}
		initObj.rsid = constants.rsidDev;
		if (initObj.environment === 'production' || initObj.environment === 'prod') {
			initObj.rsid = constants.rsidProd;
		}
		if (window.adobeIMS && window.adobeIMS.isSignedInUser && window.adobeIMS.isSignedInUser()) {
			initObj.sendEnterprise = false;
		}
		else {
			initObj.sendEnterprise = true;
		}

		this.ingest = new Ingest(initObj);

		logMetricsCollection = 0;
		logAnalytics = 0;

		if (window.logAppsMetrics && window.logAppsMetrics > 0) {
			logMetricsCollection = 1;
		}
		if (window.logAnalytics && window.logAnalytics > 0) {
			logAnalytics = 1;
		}
	}

	/**
	 * [initAnalytics Init Ingest]
	 * @return {[none]}
	 */
	initAnalytics() {
		ingestUtil.initAnalytics(this.ingest);
	}

	/**
	 * [logAnalytics A utility method to set multiple values at once]
	 * @param  {[object of key/value pairs]} dataObject [events]
	 * @return {[none]}
	 */
	logAnalytics(dataObject: Object) {
		ingestUtil.setIngestDataValue(this.ingest, dataObject);

		this.ingest.addToCollection();
	}

	/**
	 *
	 * @param {eventObject} genericAnalyticEvent
	 */
	// genericAnalyticEvent(appConfig:Object,eventType:string,eventSubtype:string,viewType:string,expCampaignID?:string,expVariationID?:string, eventValue?:string) {
	genericAnalyticEvent(eventObject: Object) {
		let osVersion = this.ingest.getOSVersion();
		// removing win or mac from osversion as per haresh suggestion
		if (appsUtil.isWin()) {
			osVersion += `:${DeviceDetectionUtil.is64bitWindows() ? '64' : '32'}`;
		}
		else if (appsUtil.isMacOS()) {
			osVersion += `:${DeviceDetectionUtil.is64bitMac() ? '64' : '32'}`;
		}

		const dataObject: Object = {
			setEventContextGUID: eventObject.contextGuid,
			setEventWorkflow: eventObject.workflow,
			setEventSubcategory: eventObject.subCategory,
			setEventType: eventObject.type,
			setEventSubtype: eventObject.subType ? ingestUtil.replaceSpaces(eventObject.subType).toLowerCase() : null,
			setErrorType: eventObject.errorType,
			setEventValue: eventObject.value,
			setEventErrorDesc: eventObject.errorDesc,
			setFrameworkName: eventObject.frameworkName,
			setEnvComName: eventObject.componentName,
			setEventIDP: eventObject.idp,
			setConsumerClientID: eventObject.productId,
			setOSVersion: osVersion,
			setExpCampaignID: eventObject.campaignId,
			setExpVariationID: eventObject.variationId,
			setContentAction: eventObject.contentAction
		};

		if (!analyticsUtil.isSplitEvent(dataObject)) {
			setExpCampaignAndVariation(dataObject);
		}

		const productId = eventObject.productId === 'premiere-rush' ? 'rush' : eventObject.productId;
		if (productData[productId]) {
			dataObject.setConsumerName = eventObject.productName ? eventObject.productName : productData[productId].name;
			const consumerVersion = CompatibilityUtil.getSupportedAppVersion(productData[productId].sapCode);
			if (consumerVersion) {
				dataObject.setConsumerVersion = consumerVersion;
			}
		}

		if (appsUtil.isFFCFallback) {
			dataObject.setEventContextSequence = 'ffc-fallback';
		}

		dataObject.setIngestContextGuid = analyticsUtil.contextGuid;
		dataObject.setIngestContextParams = analyticsUtil.contextParams;
		dataObject.setIngestContextInit = analyticsUtil.contextInit;

		this.logAnalytics(dataObject);

		if (logAnalytics) {
			console.log('genericAnalyticEvent: ', dataObject);
		}

		return ingestUtil.sendToIngest(this.ingest, logMetricsCollection);
	}

	getVisitorGuid() {
		return this.ingest.getVisitorGuid();
	}
}
